module.exports = __webpack_public_path__ + "0f358510861736791edc8f91eb88aa27.svg";